/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlClientMFAAttestation
 */
export interface ControlClientMFAAttestation {
    /**
     * 
     * @type {boolean}
     * @memberof ControlClientMFAAttestation
     */
    mfa_email: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlClientMFAAttestation
     */
    mfa_access: boolean;
}

/**
 * Check if a given object implements the ControlClientMFAAttestation interface.
 */
export function instanceOfControlClientMFAAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mfa_email" in value;
    isInstance = isInstance && "mfa_access" in value;

    return isInstance;
}

export function ControlClientMFAAttestationFromJSON(json: any): ControlClientMFAAttestation {
    return ControlClientMFAAttestationFromJSONTyped(json, false);
}

export function ControlClientMFAAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlClientMFAAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_email': json['mfa_email'],
        'mfa_access': json['mfa_access'],
    };
}

export function ControlClientMFAAttestationToJSON(value?: ControlClientMFAAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_email': value.mfa_email,
        'mfa_access': value.mfa_access,
    };
}

